export default __webpack_public_path__ + "static/media/rooneyMen.636a2860.jpg";